<template>
  <div class="file-name-section">
    <div class="file-name-title">
      <div class="font-bold text-14">File Name</div>
      <div class="mt-1 text-12">Short description</div>
    </div>
    <div>
      <cert-input-text
        @input="$emit('input', $event)"
        :value="value"
        :maxLength="256"
      ></cert-input-text>
    </div>
  </div>
</template>

<script>
import CertInputText from "@/components/form/CertInputText.vue";
export default {
  name: "CertFileNameSection",
  props: {
    value: {
      type: String,
    },
  },
  components: {
    CertInputText,
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/tailwind.scss";

.file-name-section {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  justify-content: center;
  padding: 32px 0;
}

.file-name-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>